import { Routes, Route } from 'react-router';

import Layout from '@/components/templates/Layout';
import PermissionsWrapper from '@/components/templates/PermissionsWrapper';
import { Rules } from '@/modules/rules/pages/Rules/Rules';

const RulesRouter: React.FC = () => {
  return (
    <Layout>
      <PermissionsWrapper module="rules">
        <Routes>
          <Route path="/:ruleId?" element={<Rules />} />
        </Routes>
      </PermissionsWrapper>
    </Layout>
  );
};
RulesRouter.displayName = 'RulesRouter';

export default RulesRouter;
